var getBuilderState = function getBuilderState(state) {
  return state.builders;
};

var DEFAULT_BUILDER_DATA = {};

var getBuilderData = function getBuilderData(state, id) {
  var builderState = getBuilderState(state);
  return builderState[id] || DEFAULT_BUILDER_DATA;
};

export { getBuilderData, getBuilderState };
